























































































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchMS } from './fetchMS';
import Confirmation from '@/components/Confirmation.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import modalVerDetalleSAV from '@/pantallas/Conecta/solicitudAnulacionVenta/modalVerDetalleSAV.vue';

import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    modalVerDetalleSAV,
    'app-confirmacion': Confirmation,
  },
})
export default class SolicitudAnulacionVenta extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.SolicitudAnulacionVenta;
  //@Prop({ default: null }) filtro_cliente: any;
  //@Prop({ default: null }) filtro_nota_de_venta: any;
  //@Prop({ default: null }) filtro_estados: any;
  //@Prop({ default: null }) SAV_SELECCIONADA: any;
  //@Prop({ default: null }) NDV_SELECCIONADA: any;

  filtro_cliente: any;
  filtro_nota_de_venta: any;
  filtro_estados: any;
  filtro_razon_estado: any;
  SAV_SELECCIONADA: any;
  NDV_SELECCIONADA: any;

  gridApi: GridApi = null;
  GRILLA_SAV: any = []; //contiene la data de la lista de SAV
  ModalDetalleSAV: boolean = false; //controla el estado del modal
  model_filtro_cliente: any = null;
  model_filtro_nota_de_venta: any = null;
  model_filtro_estados: any = null;
  model_filtro_razon_estado: any = null;
  model_filtro_inicio: any = null;
  model_filtro_fin: any = null;
  model_filtro_devuelto: any = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';
  filtro_devuelto: any = [{ devuelto: 'SI' }, { devuelto: 'NO' }];

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };
  accionExportarExcel: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };
  accionDevolverAFinanzas: PermisoAccion = {
    accionCodigo: 126,
    visible: false,
  };
  /*
  accionAnular: PermisoAccion = {
    accionCodigo: 94,
    visible: false,
  };
  */
  accionesTotales: PermisoAccion[] = [
    this.accionVerDetalle,
    this.accionExportarExcel,
    this.accionDevolverAFinanzas,
    //this.accionAnular,
  ];
  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handlerbuttonmodalVerDetalle);
    actionsEvent.onExportar(this.handlerbuttonmodalExportar);
    actionsEvent.onDevolverAFinanzas(this.handlerbuttonmodalDevolverAFinanzas);
    //actionsEvent.onAnular(this.handlerbuttonmodanular);
  }
  handlerbuttonmodalVerDetalle(params: ICellRendererParams) {
    this.SAV_SELECCIONADA = params.data['Número SAV'];
    this.NDV_SELECCIONADA = params.data['Nombre de Nota de Venta'];
    this.ModalDetalleSAV = true;
    console.log(this.SAV_SELECCIONADA);
  }
  handlerbuttonmodalExportar(params: ICellRendererParams) {
    this.SAV_SELECCIONADA = params.data['Número SAV'];
    this.NDV_SELECCIONADA = params.data['Nombre de Nota de Venta'];
    this.loadingService.showLoading(undefined, 'exportar_detalle_sav');
    let body: { [key: string]: string } = {
      SAV_SELECCIONADA: this.SAV_SELECCIONADA,
      NDV_SELECCIONADA: this.NDV_SELECCIONADA,
    };
    return fetchMS(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
      },
      'exportar_detalle_sav'
    )
      .then((data: any) => {
        if (Number(data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('exportar_detalle_sav');
        console.log(data.data);
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('exportar_detalle_sav');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('exportar_detalle_sav');
        return null;
      });
  }

  handlerbuttonmodalDevolverAFinanzas(params: ICellRendererParams) {
    this.SAV_SELECCIONADA = params.data['Número SAV'];
    this.NDV_SELECCIONADA = params.data['Nombre de Nota de Venta'];
    this.Modal_confirmar_TEXTO =
      '¿Está seguro que desea devolver a finanzas items de ' +
      this.NDV_SELECCIONADA +
      ' ?';
    this.mostrarModalCONFIRMAR = true;
    //la logica de apretar SI se procesa en handle_devolver_a_finanzas
  }

  ModalDetalleSAV_callback(event: any) {
    console.log('ModalDetalleSAV_callback', event);
    this.ModalDetalleSAV = event;
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número SAV',
        field: 'Número SAV',
        hide: true,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Nombre SAV',
        field: 'Nombre SAV',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Fecha de Creación',
        field: 'Fecha de Creación',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 200,
      },
      {
        headerName: 'Fecha de Registro',
        field: 'Fecha de Registro',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 200,
      },
      {
        headerName: 'Nombre de Nota de Venta',
        field: 'Nombre de Nota de Venta',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Nombre de Factura',
        field: 'Nombre de Factura',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'RUT del Cliente',
        field: 'RUT del Cliente',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Razón Social',
        field: 'Razón Social',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Tipo de Anulación',
        field: 'Tipo de Anulación',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Motivo de Anulación',
        field: 'Motivo de Anulación',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 250,
      },
      {
        headerName: 'Observaciones',
        field: 'Observaciones',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Cant. de Equipos',
        field: 'Número de Equipos',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Monto',
        field: 'Monto',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Estado CRM',
        field: 'Estado CRM',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Razón Estado CRM',
        field: 'Razon Estado CRM',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Devuelto a Finanzas',
        field: 'Devuelto Finanzas',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Número de Movimiento',
        field: 'Número de Movimiento',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Propietario',
        field: 'Propietario',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Usuario Modifica',
        field: 'Usuario Modifica',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Fecha Modifica',
        field: 'Fecha Modifica',
        hide: false,
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
    ].map(x => ({
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };
  async handleGridReady(event: GridReadyEvent) {
    console.log('handleGridReady');
    this.GRILLA_SAV = await this.get_grid_listas_sav();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.GRILLA_SAV);
    this.gridApi.setDomLayout('autoHeight');

    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
  }

  async handle_devolver_a_finanzas() {
    /*
    #TODO generar accion nueva con texto Devolver a finanzas
    #mover nuestro a bodega
    #mover del API inet 101 a la 100 (ubiciaciones) salida 101 y entrada 100
    */

    console.log(this.SAV_SELECCIONADA, this.NDV_SELECCIONADA);
    this.loadingService.showLoading(undefined, 'handle_devolver_a_finanzas');
    return fetchMS(
      {
        id_sav: this.SAV_SELECCIONADA,
        ndv: this.NDV_SELECCIONADA,
        usuario_id: this.getUserID() /*  PARAMETRO  */,
      },
      'devolver_a_finanzas'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('handle_devolver_a_finanzas');
        this.mostrarModalCONFIRMAR = false;
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('handle_devolver_a_finanzas');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('handle_devolver_a_finanzas');
        return null;
      });
  }

  async get_grid_listas_sav(filter_data: any = null) {
    if (filter_data == null) {
      //aplico por defecto el filtro que da un mes en base al campo fecha_creacion
      filter_data = {
        filtro_inicio: moment(new Date()).subtract(1, 'months'),
        filtro_fin: moment(new Date()),
      };
    }
    this.loadingService.showLoading(undefined, 'get_grid_data_savs');

    return fetchMS(filter_data, 'inicio')
      .then((data: any) => {
        this.loadingService.hideLoading('get_grid_data_savs');
        this.filtro_nota_de_venta = data.data.FILTROS.NOTA_VENTAS.LISTA;
        this.filtro_cliente = data.data.FILTROS.CLIENTES.LISTA;
        this.filtro_estados = data.data.FILTROS.ESTADOS.LISTA;
        this.filtro_razon_estado = data.data.FILTROS.RAZON_ESTADO.LISTA;
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async sincronizar() {
    this.loadingService.showLoading(undefined, 'sincronizar');
    return fetchMS({}, 'api_to_table')
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          console.log(data);
        }
        this.loadingService.hideLoading('sincronizar');
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('handle_devolver_a_finanzas');
        this.loadingService.hideLoading('sincronizar');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('sincronizar');
        return null;
      });
  } //end sincronizar()

  async cleanfilters() {
    console.log('cleanfilters');
    this.model_filtro_inicio = moment(new Date()).subtract(1, 'months');
    this.model_filtro_fin = moment(new Date());
    this.model_filtro_cliente = null;
    this.model_filtro_estados = null;
    this.model_filtro_razon_estado = null;
    this.model_filtro_nota_de_venta = null;
    this.model_filtro_devuelto = null;
    this.GRILLA_SAV = await this.get_grid_listas_sav();
    this.gridApi.setRowData(this.GRILLA_SAV);
  }

  async applyfilters() {
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_estados: this.model_filtro_estados,
      filtro_razon_estado: this.model_filtro_razon_estado,
      filtro_nota_de_venta: this.model_filtro_nota_de_venta,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_devuelto: this.model_filtro_devuelto,
    };
    this.GRILLA_SAV = await this.get_grid_listas_sav(body);
    this.gridApi.setRowData(this.GRILLA_SAV);
  }

  async btn_exportar() {
    this.loadingService.showLoading(undefined, 'btn_exportar');
    let body: { [key: string]: string } = {
      filtro_cliente: this.model_filtro_cliente,
      filtro_estados: this.model_filtro_estados,
      filtro_razon_estado: this.model_filtro_razon_estado,
      filtro_nota_de_venta: this.model_filtro_nota_de_venta,
      filtro_inicio: this.model_filtro_inicio,
      filtro_fin: this.model_filtro_fin,
      filtro_devuelto: this.model_filtro_devuelto,
    };
    return fetchMS(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
      },
      'exportar_grilla_sav'
    )
      .then((data: any) => {
        if (Number(data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        console.log(data.data);
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('btn_exportar');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('btn_exportar');
        return null;
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(id);
    return id;
  }
  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  async confirmCallback(val: boolean) {
    console.log('confirmCallback', val);
    if (val == true) {
      this.handle_devolver_a_finanzas();
    } else {
      this.mostrarModalCONFIRMAR = false;
    }
  }
} //end class SolicitudAnulacionServicio
